import { render, staticRenderFns } from "./GhostwritingRefusalModal.vue?vue&type=template&id=456793fe&"
import script from "./GhostwritingRefusalModal.vue?vue&type=script&lang=js&"
export * from "./GhostwritingRefusalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports